import { ComponentSize } from '../../../types';

export enum ButtonVariant {
  STRONG = 'strong',
  SOFT = 'soft',
  GHOST = 'ghost',
}

export enum ButtonColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DESTRUCTIVE = 'destructive',
  NEUTRAL = 'neutral',
  TERTIARY = 'tertiary',
  GONG = 'gong',
  SALESLOFT = 'salesloft',
  NAV_MENU = 'nav-menu',
}

export type StrongOnlyButtons = ButtonColor.NAV_MENU | ButtonColor.GONG | ButtonColor.SALESLOFT;

export type BaseButtonProps = {
  // Applies active styles.
  active?: boolean;
  // Disables the button.
  disabled?: boolean;
  // Applies loading styles.
  loading?: boolean;
  // Button size.
  size?: ComponentSize;
  // Tooltip text.
  tooltip?: string;
  // Button click handler.
  onClick?: (e: React.MouseEvent) => Promise<void> | void;
  // Button hover callback.
  onHover?: (hover: boolean) => void;
  // Button key down callback.
  onKeyDown?: (e: KeyboardEvent) => void;
} & (
  | {
      color?: Exclude<ButtonColor, StrongOnlyButtons>;
      variant?: ButtonVariant;
    }
  | {
      color: StrongOnlyButtons;
      variant?: ButtonVariant.STRONG;
    }
);
